import Pusher from 'pusher-js';
import Echo from 'laravel-echo';

window.Pusher = Pusher;

// Host/puerto/TLS del WebSocket por env (Soketi). Defaults = dev local.
// Prod/staging: VITE_APP_WS_HOST=ws-stg.escality.online, WS_PORT=443, WS_TLS=true.
const wsHost = import.meta.env.VITE_APP_WS_HOST || 'ws.escality.local';
const wsPort = Number(import.meta.env.VITE_APP_WS_PORT || 6001);
const forceTLS = import.meta.env.VITE_APP_WS_TLS === 'true';

const echo = new Echo({
  broadcaster: 'pusher',
  key: import.meta.env.VITE_APP_PUSHER_APPKEY,
  cluster: import.meta.env.VITE_APP_PUSHER_CLUSTER || 'local',
  wsHost,
  wsPort,
  wssPort: wsPort,
  forceTLS,
  encrypted: forceTLS,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  authEndpoint: import.meta.env.VITE_APP_BASE_URL + '/broadcasting/auth',
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  },
});

window.Echo = echo;
export default echo;
